import React from "react";
import {
  FormControl,
  FormHelperText,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import { styleForTextField } from "../../../utils/TextField/TextField";

const FormCSDropdown = ({
  value,
  options = [],
  onChange,
  disabled = false,
  placeholder = "-",
  error = false,
  helperText = "",
}) => {
  const stringValue = value == null ? "" : String(value);

  return (
    <FormControl fullWidth error={error}>
      <Select
        size='small'
        fullWidth
        displayEmpty
        value={stringValue}
        onChange={onChange}
        disabled={disabled}
        error={error}
        sx={{
          ...styleForTextField(),
          bgcolor: "white",
          "& .MuiSelect-select": {
            fontSize: "0.95rem",
            fontWeight: 500,
            letterSpacing: 0.2,
          },
        }}
        renderValue={(selected) => {
          if (selected === "") {
            return (
              <Typography
                component='span'
                variant='body2'
                color='text.secondary'
                sx={{ fontWeight: 500 }}
              >
                {placeholder}
              </Typography>
            );
          }
          const match = options.find((o) => String(o.value) === String(selected));
          return match?.label ?? selected;
        }}
      >
        {options.map((option) => (
          <MenuItem key={String(option.value)} value={String(option.value)}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

export default FormCSDropdown;
